import $ from "jquery";

export const navigation = () => {
  $(".mobile-menu-close").on("click", () => {
    $("html").removeClass("menu-active");
  });

  $(".mobile-menu-btn").on("click", () => {
    $("html").addClass("menu-active");
  });

  $(window)
    .on("resize", () => {
      if ($(window).width() > 1199.98) {
        $("html").removeClass("menu-active");
      }
    })
    .resize();
};
